import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { DadosContatoAba8DTO } from '../../model/DadosContatoAba8DTO';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";

@Injectable()
export class DadosParentescoServiceAba9 extends GenericService {
    private path = environment.url + 'api/v1/';

    constructor(http: HttpClient) {
        super(http);
    }

    getDadosParentesco(): Observable<any> {
        return this.http.get<any>(this.path + 'parentesco/obter-parentescos');
    }

    getServidor(nomeServidor: string): Observable<any> {
        return this.http.get<any>(this.path + `servidor/obter/${nomeServidor}/pagina/${0}/tamanho/${10}`);
    }

    getListaParentesco(): Observable<any> {
        return this.http.get<any>(this.path + 'grau-parentesco');
    }

    atualizarDadosParentesco(data): Observable<any> {
        return this.http.post(this.path + 'parentesco/salvar-parentesco', data);
    }

    deletarParentesco(idRecadServParent: number) {
        return this.http.put(this.path + `parentesco/remover-parentescos/${idRecadServParent}`, {});
    }
}